import { useEffect, useRef, useState } from "react";
import apiInstance from "../../apiInstance";
import PopupModal from "../Popups/PopupModal";
import { useNavigate } from "react-router-dom";

const SubscriptionsTable = ({
    bulkSelect = false,
    subscriptions = [],
    selectedItems = [],
    handleSelectAll = () => {},
    handleSelect = () => {},
    onEdit = () => {},
    onDelete = () => {}
}) => {

    const navigate = useNavigate();

    return (
        <>
            <table className="mjsdev-table hover-enabled">
                <thead>
                    <tr>
                        {bulkSelect &&
                            <th>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={subscriptions.length > 0 && selectedItems.length === subscriptions.length}
                                />
                            </th>
                        }
                        <th>Order ID</th>
                        <th>Customer</th>
                        <th>Status</th>
                        <th>Site Name</th>
                        <th>Amount($)</th>
                        <th>Start Date</th>
                        <th>Renewal Date</th>
                        <th></th>
                    </tr>
                </thead>
                {subscriptions.length > 0 ? (
                    <tbody>
                        {subscriptions.map((sub, index) => (
                            <tr 
                                key={sub.id}
                                onClick={() => navigate(`/devadmin/subscriptions/${sub.id}`)}
                            >
                                {bulkSelect &&
                                    <td>
                                        <input
                                            type="checkbox"
                                            onClick={(e) => e.stopPropagation()}
                                            onChange={() => {handleSelect(sub.id)}}
                                            checked={selectedItems.includes(sub.id)}
                                        />
                                    </td>
                                }
                                <td>
                                    #{sub?.subscription_number || ""}
                                </td>
                                <td>
                                    {sub?.userName || "-"}
                                </td>
                                <td>{sub?.paused ? (
                                    <span title="All invoices generated by this subscription will be marked as uncollectible.">Paused</span>
                                ) : sub?.status || '-'}</td>
                                <td>
                                    {sub?.siteName || "--"}
                                </td>
                                <td>
                                    {sub?.amount || process.env.REACT_APP_STRIPE_MONTHLY_PRICING}
                                </td>
                                <td>
                                    {sub.createdAt
                                        ? new Date(
                                            sub.createdAt
                                        ).toDateString()
                                        : "—"}
                                </td>
                                <td>
                                    {sub.currentPeriodEnd
                                        ? new Date(
                                            sub.currentPeriodEnd
                                        ).toDateString()
                                        : "—"}
                                </td>
                                <td className="mjsdev-table-actions">
                                    <i                                        
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onEdit(sub)
                                        }}
                                        title="Edit Subscription"
                                        className="fa-solid fa-pen-to-square"
                                    ></i>
                                    <i                                        
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            onDelete(sub.id)
                                        }}
                                        title="Delete Subscription"
                                        className="fa-solid fa-trash"
                                    ></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <tbody>
                        <tr>
                            <td colSpan="8" className="mjsdev-msg">
                                No subscriptions found.
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </>
    );
};

export default SubscriptionsTable;
